module.exports = __webpack_public_path__ + "public/static/img/register-page-img-01.152e965.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register-page-img-01.svg
// module id = ayGs
// module chunks = 1